import { NgOptimizedImage } from '@angular/common';
import { Component, output } from '@angular/core';
import { AnimateComponent } from '@app/components/animate/animate.component';
import { SectionType } from '@app/models';

@Component({
  selector: 'app-what-todo-section',
  templateUrl: './what-todo-section.component.html',
  styleUrls: ['./what-todo-section.component.scss'],
  standalone: true,
  imports: [NgOptimizedImage, AnimateComponent],
})
export class WhatTodoSectionComponent {
  public readonly navigationClick = output<SectionType>();

  protected readonly SectionType = SectionType;
}
